export enum OrderStatus {
  PENDING = "pending",
  ACCEPTED = "accepted",
  PREPARING = "preparing",
  PREPARED = "prepared",
  READY_FOR_PICKUP = "ready_for_pickup",
  IN_DELIVERY = "in_delivery",
  DELIVERED = "delivered",
  AUTO_FINALIZED = "auto_finalized",
  CANCELED = "canceled",
  SCHEDULED = "scheduled",
}

export enum OrderStatusLabel {
  pending = "New",
  accepted = "Accepted",
  preparing = "Preparing",
  prepared = "Prepared",
  ready_for_pickup = "Ready for pickup",
  in_delivery = "In delivery",
  delivered = "Delivered",
  auto_finalized = "Auto finalized",
  canceled = "Canceled",
  scheduled = "Scheduled",
}

export enum ChargeStatusLabel {
  pending = "pending",
  succeeded = "succeeded",
  failed = "failed",
  refund_requested = "refund requested",
  refund_succeeded = "refund succeeded",
  refund_failed = "refund failed",
}

export enum ChargeFailureReasonLabel {
  insufficient_funds = "insufficient funds",
  expired_balance = "expired balance",
  refund_failed = "refund_failed",
  internal_error = "internal_error",
}

export enum EOrderTypeValue {
  PICK_UP = "1",
  DELIVERY = "2",
  EAT_IN = "3",
}

export enum EOrderTypeLabel {
  PICK_UP = "Pick Up",
  DELIVERY = "Delivery",
  EAT_IN = "Eat In",
}

export enum EPaymentMethod {
  CARD = "Card",
  CASH = "Cash",
}

export interface OrderStatusHistoryItem {
  previousStatus: string | null;
  newStatus: "pending" | string;
  timestamp: string;
}

export interface OrderParams {
  offset?: number;
  limit?: number;
  sortBy?: string;
  sortingOrder?: string;
}

export enum OrderFilterTypes {
  createdAfter = "createdAtAfter",
  updatedAfter = "updatedAtAfter",
  sidLike = "sidLike",
  orderStatus = "orderStatus",
}

export enum OrderFilterNames {
  createdAtAfter = "Created after",
  updatedAtAfter = "Updated after",
  sidLike = "Order ID",
  orderStatus = "Order status",
}

export type OrderStatusDto =
  | "pending"
  | "accepted"
  | "preparing"
  | "prepared"
  | "ready_for_pickup"
  | "in_delivery"
  | "delivered"
  | "auto_finalized"
  | "canceled";

export type ChargeStatusDto =
  | "pending"
  | "succeeded"
  | "failed"
  | "refund_requested"
  | "refund_succeeded"
  | "refund_failed";

export type ChargeFailureReasonDto =
  | "insufficient_funds"
  | "expired_balance"
  | "refund_failed"
  | "internal_error"
  | null;

export type CustomerAddressResponseDto = {
  id: string;
  name: string;
  lng: number;
  lat: number;
  city: string;
  area: string;
  block: string;
  street: string;
  building: string;
  floor: string | null;
  flat: string | null;
  phone: string;
  additionalInfo: string | null;
  isSelected: boolean;
  isInAnyDeliveryZone?: boolean;
  createdAt: string;
  updatedAt: string;
};

export type OrderItemResponseDto = {
  productId: string;
  productPLU: string;
  productName: string;
  quantity: number;
  fmcCentsPrice: number;
  remark: string;
};

export type DeliveryResponseDto = {
  id: string;
  customerId: string;
  locationId: string;
  deliveryAddress: CustomerAddressResponseDto;
  deliverectValidationId: string | null;
  deliveryProvider: "deliverect" | "own";
  expiresAt: string;
  estimatedDeliveryTime: string | null;
  estimatedDeliveryTimeEnd: string | null;
  orderId: string | null;
  createdAt: string;
  updatedAt: string;
};

export type OrderStatusHistoryItemResponseDto = {
  previousStatus: OrderStatusDto | null;
  newStatus: OrderStatusDto;
  timestamp: string;
};

export type OrderResponseDto = {
  id: string;
  sid: string;
  menuId: string;
  locationId: string;
  locationName: string | null;
  deliveryId: string;
  customerId: string;
  delivery: DeliveryResponseDto;
  items: OrderItemResponseDto[];
  totalFiatCentsPrice: number;
  totalFmcCentsPrice: number;
  orderStatus: OrderStatusDto;
  chargeStatus: ChargeStatusDto;
  chargeFailureReason: ChargeFailureReasonDto;
  orderStatusHistory: OrderStatusHistoryItemResponseDto[];
  chargeStatusHistory: OrderStatusHistoryItemResponseDto[];
  createdAt: string;
  updatedAt: string;
};

export type GetOrdersResponseDto = {
  totalCount: number;
  items: OrderResponseDto[];
};
